module.exports = __webpack_public_path__ + "static/media/citrus-quickpoll-a-or-b-aorb.e5fb384c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/images/citrus-quickpoll-a-or-b-aorb.png
// module id = 256
// module chunks = 1